module.exports = __webpack_public_path__ + "media/images/desktop/lets-tap-title-086c1747ed4d2961c8c30165d029115c.png";